import _axios from "axios";

const client = _axios.create({ baseURL: process.env.REACT_APP_API_ENDPOINT });
client.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  return config;
});

export const surveyApi = {
  pending: async () => (await client.get("/student/surveys/pending")).data,
  start: async (assignmentId) => (await client.post(`/student/surveys/assignments/${assignmentId}/start`)).data,
  answer: async (responseId, questionId, value) =>
    (await client.put(`/student/surveys/responses/${responseId}/answers/${questionId}`, { value })).data,
  complete: async (responseId) => (await client.post(`/student/surveys/responses/${responseId}/complete`)).data,
};
